// Auto-generated contract reads for Public domain — DO NOT EDIT.
//
// Each pure contract read ([ContractRead] [WolverineGet]) emits a typed params
// interface + a route/querystring path builder. Feed the path to the shared app
// client: api.get<Response>(...). See wiki/feature-contract-reads.md §4.

export interface ConfigAuthParams {
}

/** GET /api/config/auth — pure contract read (no DB; any authenticated principal incl. Guest). */
export function configAuthPath(_params: ConfigAuthParams = {}): string {
  return '/config/auth';
}

export interface VersionParams {
}

/** GET /api/version — pure contract read (no DB; any authenticated principal incl. Guest). */
export function versionPath(_params: VersionParams = {}): string {
  return '/version';
}

